import useWindowDimensions from 'react-components/Hooks/useWindowDimensions'

export function useIsTablet() {
  const { width } = useWindowDimensions()
  return width <= 960
}
